// import { feedHubReducer } from "Artifacts/Feed/redux/Reducer";
/// <amd-module name="Artifacts/FeedPicker/redux/Module" />
import { FeedPickerActions } from "Artifacts/FeedPicker/redux/Actions";
import { IFeedPickerState } from "Artifacts/FeedPicker/redux/Contracts";
import { feedPickerReducer } from "Artifacts/FeedPicker/redux/Reducer";
import rootSaga from "Artifacts/FeedPicker/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

export interface IFeedPickerModuleState {
  // This layer is so IFeedState isn't in redux store root with other modules
  feedPicker: IFeedPickerState;
}

const _feedPickerModule: ISagaModule<IFeedPickerModuleState> = {
  id: "feed-picker",
  reducerMap: {
    feedPicker: feedPickerReducer,
  },
  initialActions: [FeedPickerActions.loadData()],
  sagas: [rootSaga],
};

export const FeedPickerModule = [_feedPickerModule];
